module.exports = __webpack_public_path__ + "img/serialization_diagram.6b4e4feb.png";